import { Quaternion } from "@babylonjs/core/Maths/math.vector";
import { Vector2 } from "@babylonjs/core/Maths/math.vector";
import { MoveRoute } from './tools';
import { AbstractInteractors } from "./interactors";
import { EditRoutes } from './../cmd/EditRoutes';
import { RouteEnding } from './../mdl/Route';
import { Util } from "../utils/Util";
import { PI_DIV2 } from "@egr/wcf/modules/utils/math";
import { VECTOR3_X } from "@egr/wcf/modules/core/utils/MathUtils";
import { getRotationQuaternion } from "@egr/wcf/modules/core/utils/MeshUtils";
export class RouteInteractors extends AbstractInteractors {
    constructor(pRoomManager, pRoute) {
        super(pRoomManager);
        this.mRoute = pRoute;
        this.mLengthInteractors = [null, null, null, null, null, null];
    }
    showInteractors(pShow) {
        this.clear();
        if (!pShow || this.mApp.model.selection.length !== 1)
            return;
        this.mInteractorManager.enabled = true;
        let tCenter = Vector2.Center(this.mRoute.startPoint, this.mRoute.endPoint);
        let t3dRotation = getRotationQuaternion(this.mRoute.node).clone();
        t3dRotation.multiplyInPlace(Quaternion.RotationAxis(VECTOR3_X, PI_DIV2));
        this._updateLengthInteractors();
        //this.createSideIndicators(t3dRotation);
        //move start
        let tInteractor = this.createInteractor("dot-interactor", Util.to3d(this.mRoute.startPoint), null, 0, t3dRotation);
        tInteractor.onTriggerAction = () => this.startMoveRoute(MoveRoute.Mode.MoveStart);
        //move end
        tInteractor = this.createInteractor("dot-interactor", Util.to3d(this.mRoute.endPoint), null, 0, t3dRotation);
        tInteractor.onTriggerAction = () => this.startMoveRoute(MoveRoute.Mode.MoveEnd);
        //move route
        tInteractor = this.createInteractor("move-interactor", Util.to3d(tCenter), null, 0, t3dRotation);
        tInteractor.onTriggerAction = () => this.startMoveRoute(MoveRoute.Mode.MoveRoute);
    }
    clear() {
        this.mInteractorManager.clear();
        this.mInteractorManager.enabled = false;
        this.mLengthInteractors = [null, null, null, null, null, null];
    }
    //// internal //////////////////////////////////////////////////////////////////////////////
    /** @internal */
    _updateLengthInteractors() {
        this.mInteractorManager.enabled = true;
        //let tDir = this.mRoute.endPoint.subtract(this.mRoute.startPoint);
        //let tDirP = perpendicularVector2(tDir);
        let t3dRotation = getRotationQuaternion(this.mRoute.node).clone();
        t3dRotation.multiplyInPlace(Quaternion.RotationAxis(VECTOR3_X, PI_DIV2));
        //length left
        /*
        let tSideCenter = Vector2.Center(this.mRoute._edges[2], this.mRoute._edges[3]);
        let tSideLengthL = this.mRoute.getRouteLengthL();
        let tInteractorL = this.createTextInteractor(
            Util.to3d(tSideCenter),
            this.lengthToString(tSideLengthL),
            Util.to3d(tDir).normalize(),
            Util.to3d(tDirP).normalize(), -14, t3dRotation, false, this.mLengthInteractors[0]);
        this.mLengthInteractors[0] = tInteractorL;
        tInteractorL.onTriggerAction = () => this.showInputField(
            RouteInteractors.INPUT_LENGTH_L, tSideLengthL, tInteractorL);

        //length right
        tSideCenter = Vector2.Center(this.mRoute._edges[0], this.mRoute._edges[1]);
        let tSideLengthR = this.mRoute.getRouteLengthR();
        let tInteractorR = this.createTextInteractor(
            Util.to3d(tSideCenter),
            this.lengthToString(tSideLengthR),
            Util.to3d(tDir).normalize(),
            Util.to3d(tDirP).normalize(), 14, t3dRotation, false, this.mLengthInteractors[1]);
        this.mLengthInteractors[1] = tInteractorR;
        tInteractorR.onTriggerAction = () => this.showInputField(
            RouteInteractors.INPUT_LENGTH_R, tSideLengthR, tInteractorR);
        */
        this.updateDistTextInteractors();
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    handleInputField(pId, pOldLength, pNewLength, pInteractor) {
        switch (pId) {
            case RouteInteractors.INPUT_LENGTH_L:
                this.setRouteLength(pNewLength, true, pInteractor);
                break;
            case RouteInteractors.INPUT_LENGTH_R:
                this.setRouteLength(pNewLength, false, pInteractor);
                break;
            /*
            case RouteInteractors.INPUT_DIST_S_L:
                this.setNeighbourDistance(RouteEnding.Start, mdl.RouteSide.Left, pOldLength,
                    pNewLength, (pInteractor as any)._negateDir);
                break;
            case RouteInteractors.INPUT_DIST_S_R:
                this.setNeighbourDistance(RouteEnding.Start, mdl.RouteSide.Right, pOldLength,
                    pNewLength, (pInteractor as any)._negateDir);
                break;
            case RouteInteractors.INPUT_DIST_E_L:
                this.setNeighbourDistance(RouteEnding.End, mdl.RouteSide.Left, pOldLength,
                    pNewLength, (pInteractor as any)._negateDir);
                break;
            case RouteInteractors.INPUT_DIST_E_R:
                this.setNeighbourDistance(RouteEnding.End, mdl.RouteSide.Right, pOldLength,
                    pNewLength, (pInteractor as any)._negateDir);
                break;
            */
            default:
                break;
        }
    }
    /*
    private createSideIndicators(p3dRotation: Quaternion): void
    {
        let tRouteDir = this.mRoute.endPoint.subtract(this.mRoute.startPoint);
        let tRouteDirP = perpendicularVector2(tRouteDir);

        let tDir = this.mRoute._edges[1].subtract(this.mRoute._edges[0]);
        let tPos = this.mRoute._edges[0].add(tDir.scale(0.05));
        let tInteractor = this.createTextInteractor(
            Util.to3d(tPos),
            "a",
            Util.to3d(tRouteDir).normalize(),
            Util.to3d(tRouteDirP).normalize(), 14, p3dRotation, true);
        tInteractor.type = core.tool.InteractorType.None;

        tDir = this.mRoute._edges[3].subtract(this.mRoute._edges[2]);
        tPos = this.mRoute._edges[3].subtract(tDir.scale(0.05));
        tInteractor = this.createTextInteractor(
            Util.to3d(tPos),
            "b",
            Util.to3d(tRouteDir).normalize(),
            Util.to3d(tRouteDirP).normalize(), -14, p3dRotation, true);
        tInteractor.type = core.tool.InteractorType.None;
    }
    */
    updateDistTextInteractors() {
        if (this.mRoute.startCxn.route != null) {
            let tRoute = this.mRoute.startCxn.route;
            //let tDir = tRoute.endPoint.subtract(tRoute.startPoint).normalize();
            //let tDirP = perpendicularVector2(tDir);
            //let tOffset = 14;
            //if (tRoute.isRouteOnLeftSide(this.mRoute))
            //    tOffset = -14;
            //3d rotation matrix
            let t3dRotation = getRotationQuaternion(tRoute.node).clone();
            t3dRotation.multiplyInPlace(Quaternion.RotationAxis(VECTOR3_X, PI_DIV2));
            /*
            let tNDist = this.mRoute._getNeighbourDistance(RouteEnding.Start, mdl.RouteSide.Left);
            if (tNDist != null) {
                let tDistance = tNDist.distance;
                let tOffsetDir = tDirP;
                if (tNDist.negateDir)
                    tOffsetDir = tOffsetDir.negate();
                let tCenter = Vector2.Center(tNDist.refPos2, tNDist.refPos1);

                let tInteractor = this.createTextInteractor(
                    Util.to3d(tCenter),
                    this.lengthToString(tDistance),
                    Util.to3d(tDir).normalize(),
                    Util.to3d(tOffsetDir).normalize(), tOffset, t3dRotation, false, this.mLengthInteractors[2]);
                tInteractor.onTriggerAction = () => this.showInputField(
                    RouteInteractors.INPUT_DIST_S_L, tDistance, tInteractor);
                (tInteractor as any)._negateDir = tNDist.negateDir;
                this.mLengthInteractors[2] = tInteractor;
            }
            */
            /*
            tNDist = this.mRoute._getNeighbourDistance(RouteEnding.Start, mdl.RouteSide.Right);
            if (tNDist != null) {
                let tDistance = tNDist.distance;
                let tOffsetDir = tDirP;
                if (tNDist.negateDir)
                    tOffsetDir = tOffsetDir.negate();
                let tCenter = Vector2.Center(tNDist.refPos2, tNDist.refPos1);

                let tInteractor = this.createTextInteractor(
                    Util.to3d(tCenter),
                    this.lengthToString(tDistance),
                    Util.to3d(tDir).normalize(),
                    Util.to3d(tOffsetDir).normalize(), tOffset, t3dRotation, false, this.mLengthInteractors[3]);
                tInteractor.onTriggerAction = () => this.showInputField(
                    RouteInteractors.INPUT_DIST_S_R, tDistance, tInteractor);
                (tInteractor as any)._negateDir = tNDist.negateDir;
                this.mLengthInteractors[3] = tInteractor;
            }
            */
        }
        else {
            if (this.mLengthInteractors[2] != null) {
                this.mInteractorManager.removeInteractor(this.mLengthInteractors[2]);
                this.mLengthInteractors[2] = null;
            }
            if (this.mLengthInteractors[3] != null) {
                this.mInteractorManager.removeInteractor(this.mLengthInteractors[3]);
                this.mLengthInteractors[3] = null;
            }
        }
        if (this.mRoute.endCxn.route != null) {
            let tRoute = this.mRoute.endCxn.route;
            //let tDir = tRoute.endPoint.subtract(tRoute.startPoint).normalize();
            //let tDirP = perpendicularVector2(tDir);
            //let tOffset = 14;
            //if (tRoute.isRouteOnLeftSide(this.mRoute))
            //    tOffset = -14;
            //3d rotation matrix
            let t3dRotation = getRotationQuaternion(tRoute.node).clone();
            t3dRotation.multiplyInPlace(Quaternion.RotationAxis(VECTOR3_X, PI_DIV2));
            /*
            let tNDist = this.mRoute._getNeighbourDistance(RouteEnding.End, mdl.RouteSide.Left);
            if (tNDist != null) {
                let tDistance = tNDist.distance;
                let tOffsetDir = tDirP;
                if (tNDist.negateDir)
                    tOffsetDir = tOffsetDir.negate();
                let tCenter = Vector2.Center(tNDist.refPos2, tNDist.refPos1);

                let tInteractor = this.createTextInteractor(
                    Util.to3d(tCenter),
                    this.lengthToString(tDistance),
                    Util.to3d(tDir).normalize(),
                    Util.to3d(tOffsetDir).normalize(), tOffset, t3dRotation, false, this.mLengthInteractors[4]);
                tInteractor.onTriggerAction = () => this.showInputField(
                    RouteInteractors.INPUT_DIST_E_L, tDistance, tInteractor);
                (tInteractor as any)._negateDir = tNDist.negateDir;
                this.mLengthInteractors[4] = tInteractor;
            }
            */
            /*
            tNDist = this.mRoute._getNeighbourDistance(RouteEnding.End, mdl.RouteSide.Right);
            if (tNDist != null) {
                let tDistance = tNDist.distance;
                let tOffsetDir = tDirP;
                if (tNDist.negateDir)
                    tOffsetDir = tOffsetDir.negate();
                let tCenter = Vector2.Center(tNDist.refPos2, tNDist.refPos1);

                let tInteractor = this.createTextInteractor(
                    Util.to3d(tCenter),
                    this.lengthToString(tDistance),
                    Util.to3d(tDir).normalize(),
                    Util.to3d(tOffsetDir).normalize(), tOffset, t3dRotation, false, this.mLengthInteractors[5]);
                tInteractor.onTriggerAction = () => this.showInputField(
                    RouteInteractors.INPUT_DIST_E_R, tDistance, tInteractor);
                (tInteractor as any)._negateDir = tNDist.negateDir;
                this.mLengthInteractors[5] = tInteractor;
            }
            */
        }
        else {
            if (this.mLengthInteractors[4] != null) {
                this.mInteractorManager.removeInteractor(this.mLengthInteractors[4]);
                this.mLengthInteractors[4] = null;
            }
            if (this.mLengthInteractors[5] != null) {
                this.mInteractorManager.removeInteractor(this.mLengthInteractors[5]);
                this.mLengthInteractors[5] = null;
            }
        }
    }
    startMoveRoute(pMode) {
        let tTool = new MoveRoute(this.mRoomManager);
        tTool.initialize(pMode, this.mRoute);
        this.mApp.tools.startTool(tTool);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    setRouteLength(pLength, pLeftRouteSide, pInteractor) {
        let tScaleInStartDirection = this.mRoomManager.changeRouteLengthToRight;
        if (pInteractor.angleFlipped)
            tScaleInStartDirection = !tScaleInStartDirection;
        let tCmd = new EditRoutes(this.mRoomManager);
        try {
            this.mRoomManager.beginCollectRouteUpdates();
            let tOldLength;
            if (pLeftRouteSide) {
                tOldLength = this.mRoute.getRouteLengthL();
            }
            else {
                tOldLength = this.mRoute.getRouteLengthR();
            }
            let tDeltaLength = pLength - tOldLength;
            let tV1 = null;
            let tV2 = null;
            let tCxn = null;
            let tEnding = null;
            if (tScaleInStartDirection) {
                tV1 = this.mRoute.endPoint;
                tV2 = this.mRoute.startPoint;
                tCxn = this.mRoute.startCxn;
                tEnding = RouteEnding.Start;
            }
            else {
                tV1 = this.mRoute.startPoint;
                tV2 = this.mRoute.endPoint;
                tCxn = this.mRoute.endCxn;
                tEnding = RouteEnding.End;
            }
            let tDir = tV2.subtract(tV1).normalize();
            let tV = tV1.add(tDir.scale(this.mRoute.getRouteLengthBase() + tDeltaLength));
            if (tCxn.route == null) {
                if (tEnding === RouteEnding.Start)
                    this.mRoute.setStartPoint(tV);
                else
                    this.mRoute.setEndPoint(tV);
            }
            else {
                if (this.mRoute.isRouteParallel(tCxn.route)) {
                    if (tCxn.routeEnding != null) {
                        if (tCxn.routeEnding === RouteEnding.Start)
                            tCxn.route.setStartPoint(tV);
                        else
                            tCxn.route.setEndPoint(tV);
                    }
                    if (tEnding === RouteEnding.Start)
                        this.mRoute.setStartPoint(tV);
                    else
                        this.mRoute.setEndPoint(tV);
                }
                else {
                    tV.subtractInPlace(tV2);
                    let tDirections = tCxn.route._getConnectedRouteDirections();
                    tCxn.route.moveRoute(tV);
                    tCxn.route._handleFlippedRoutes(tDirections);
                }
                if (tCxn.route != null) { //may be null after move
                    tCxn.route._validateConnections(2);
                }
            }
        }
        finally {
            this.mRoomManager.endCollectRouteUpdates();
            this.mApp.commands.executeCommand(tCmd);
        }
    }
}
//// private ///////////////////////////////////////////////////////////////////////////////
RouteInteractors.INPUT_LENGTH_L = "Route:length_left";
RouteInteractors.INPUT_LENGTH_R = "Route:length_right";
